import Modal from "@mui/material/Modal";
import {Slide} from "@mui/material";
import HomeDrawerHeader from "./homeScreen/HomeDrawerHeader";
import HomeDrawerMainNavigation from "./homeScreen/HomeDrawerMainNavigation";
import SystemDrawerYoutubeImage from "../images/SystemDrawerYoutubeImage";
import SystemDrawerFacebookImage from "../images/SystemDrawerFacebookImage";
import SystemDrawerInstagramImage from "../images/SystemDrawerInstagramImage";

export default function SystemAppDrawer({open, handleClose}) {
    // Used in HomeScreen to display Drawer as a side modal
    // sliding from the left to the right

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <Slide direction="right" in={open} mountOnEnter unmountOnExit>
                <div className="overflow-auto bg-backgroundLight3 w-[304px] h-[100svh] flex flex-col justify-start items-center outline-none">
                    <div className={"overflow-auto w-full grow flex flex-col"}>
                        <HomeDrawerHeader onClosePressed={handleClose}/>
                        <HomeDrawerMainNavigation />
                    </div>
                    <div className={"bg-backgroundLight1 w-full flex justify-around items-center px-[16px] py-[16px] border-t-[1px] border-greyLight3"}>
                        <SystemDrawerYoutubeImage />
                        <SystemDrawerFacebookImage />
                        <SystemDrawerInstagramImage />
                    </div>
                </div>
            </Slide>
        </Modal>
    );
}